import { type OpportunityStatusOldType, type OpportunityType } from '@/api/opportunity';
import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import { OpportunityAttributionOfflineTable } from '@/features/OpportunityAttributionOfflineTable';
import { OpportunityAttributionOnlineTable } from '@/features/OpportunityAttributionOnlineTable';

import OpportunityDetailTrendComboCharts from './OpportunityDetailTrendComboCharts';

const ONLINE_DEFAULT_SORT = {
  sortBy: 'audienceVisits',
  sortOrder: InstantSearchSortOrder.DESC,
};

const ONLINE_DEFAULT_FILTERS = [
  {
    field: 'audienceVisits',
    min: {
      inclusive: true,
      operand: '1',
    },
  },
];

const OFFLINE_DEFAULT_SORT = {
  sortBy: 'audienceOfflineEvents',
  sortOrder: InstantSearchSortOrder.DESC,
};

const OFFLINE_DEFAULT_FILTERS = [
  {
    field: 'audienceOfflineEvents',
    min: {
      inclusive: true,
      operand: '1',
    },
  },
];

const ONLINE_DEFAULT_QUERY_STATE: Partial<QueryState> = {
  ...ONLINE_DEFAULT_SORT,
  size: 10,
  filters: ONLINE_DEFAULT_FILTERS,
};

const OFFLINE_DEFAULT_QUERY_STATE: Partial<QueryState> = {
  ...OFFLINE_DEFAULT_SORT,
  size: 10,
  filters: OFFLINE_DEFAULT_FILTERS,
};

type Props = {
  opportunity?: OpportunityType;
  oppType: OpportunityStatusOldType;
};

const OpportunityDetailContent = ({ opportunity, oppType }: Props) => {
  return (
    <div className="flex flex-col gap-6">
      <OpportunityDetailTrendComboCharts opportunity={opportunity} />
      <InstantSearch defaultQueryState={ONLINE_DEFAULT_QUERY_STATE} urlSync={false}>
        <OpportunityAttributionOnlineTable
          oppType={oppType}
          opportunity={opportunity}
          defaultSort={ONLINE_DEFAULT_SORT}
          defaultFilters={ONLINE_DEFAULT_FILTERS}
          isLoading={!opportunity}
        />
      </InstantSearch>
      <InstantSearch defaultQueryState={OFFLINE_DEFAULT_QUERY_STATE} urlSync={false}>
        <OpportunityAttributionOfflineTable
          oppType={oppType}
          opportunity={opportunity}
          defaultSort={OFFLINE_DEFAULT_SORT}
          defaultFilters={OFFLINE_DEFAULT_FILTERS}
          isLoading={!opportunity}
        />
      </InstantSearch>
    </div>
  );
};

export default OpportunityDetailContent;
